import React from 'react';

/**
 * Navegación horizontal entre reportes del portal — pills (mismo estilo que el
 * selector de Plantillas de columnas del Tablero del portal).
 * - 1 reporte: no renderiza (parent maneja).
 * - 2-4 reportes: pills en línea.
 * - 5+: scroll horizontal con fade lateral.
 */
export function PortalReportNav({ reports, activeReportId, onSelect }) {
    if (!reports || reports.length <= 1) return null;
    const showScroll = reports.length >= 5;

    return (
        <nav className={`portal-report-nav ${showScroll ? '-scrollable' : ''}`} role="tablist">
            {reports.map((r) => {
                const isActive = r.id === activeReportId;
                return (
                    <button
                        key={r.id}
                        type="button"
                        role="tab"
                        aria-selected={isActive}
                        className={`portal-report-nav-item ${isActive ? '-active' : ''}`}
                        onClick={() => onSelect(r.id)}
                        title={r.description || r.name || ''}
                    >
                        {r.name}
                    </button>
                );
            })}
        </nav>
    );
}
